<template>
  <template v-if="!isFAL">
    <InputButton v-if="!isPersonalPage && hasEmail"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'email', type: 'hirestaff' })"
      >Hire staff now
    </InputButton>
    <InputButton v-if="!isPersonalPage && hasEmail"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'email', type: 'enquiry' })"
      >Enquire about rates & availability
    </InputButton>
    <InputButton v-if="hasEmail"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'email', type: 'message' })"
      >
        <template v-if="!isPersonalPage">Send a message</template>
        <template v-else>Email Agency</template>
    </InputButton>
    <InputButton v-if="hasWebsite"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'website' })"
      >Visit website
    </InputButton>
    <InputButton v-if="hasTelephone"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'telfax' })"
      >Display phone number
    </InputButton>
    <InputButton v-if="!isPersonalPage && hasEmail"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'email', type: 'callback' })"
      >Request a callback
    </InputButton>
  </template>
  <!-- FREE AGENCIES -->
  <template v-else>
    <!-- <InputButton v-if="hasEmail"
      @onClick="onClickFalCallback"
      :block="true"
      :chevron="true"
      styleType="contact"
    >
      Enquire about rates & availability
    </InputButton> -->
    <InputButton v-if="hasWebsite"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'website' })"
    >
      Visit website
    </InputButton>
    <InputButton v-if="hasTelephone"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'telfax' })"
    >
      Display phone number
    </InputButton>
  </template>
</template>
<script>

import InputButton from 'Components/InputButton.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'AgencyAdvertContactOptionsEmployer',
  components: { InputButton },
  emits: ['contactFormSelect'],
  props: {
    agency: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('pagetext', ['isPersonalPage']),
    isFAL() {
        return (this.agency.FAL == 'Y' || this.agency.FAL === true) ? true : false;
    },
    hasEmail() {
        return (this.agency.EmpEmail > 0) ? true : false;
    },
    hasTelephone() {
        return (this.agency.EmpTelFax > 0) ? true : false;
    },
    hasWebsite() {
        return (this.agency.EmpWebsite > 0) ? true : false;
    },
  },  
  methods: {
    onClickFalCallback() {
      const routeData = this.$router.resolve({
        name: 'employerCallback',
        query: { agency: this.agency.AgencyTag },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>
